import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Arrow Up Down"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-arrow-up-down',
    templateUrl: './icon-custom-sort-up-down.component.html',
    styleUrls: ['./icon-custom-sort-up-down.component.scss'],
    standalone: false
})
export class IconCustomSortUpDownComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;

}
